<template>
    <v-app>
        <v-snackbar
                v-model="snackbarEnabled"
                :color="'warning'"
                :timeout="2000"
                :top="true">
            {{snackbarText}}
        </v-snackbar>
        <v-content>
            <v-container fluid fill-height>
                <v-layout justify-center>
                    <v-flex xs12 sm8 md4>
                        <div class="mb-3">
                            <img src="@/assets/caliber2019_transparent.png"/>
                        </div>
                        <v-card class="elevation-12">
                            <v-card-title>First Time Login</v-card-title>
                            <v-subheader>Please Change Your Password</v-subheader>
                            <v-form ref="changePasswordForm" @submit="submitPassword()" onsubmit="return false">
                                <v-card-text>
                                    <v-text-field prepend-icon="mdi-lock" v-model="password" label="New Password" type="password" name="password" autofocus></v-text-field>
                                    <v-text-field prepend-icon="mdi-lock" v-model="confirmPassword" label="Confirm New Password" type="password"></v-text-field>
                                    <password v-model="password" :strength-meter-only="true"/>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-progress-circular
                                            :width="3"
                                            v-show="overlay"
                                            color="red"
                                            indeterminate="">
                                    </v-progress-circular>
                                    <v-btn color="green" type="submit">Save</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import Password from 'vue-password-strength-meter';
    import api from '@/api';
    export default {
        components : {Password},
        data() {
            return {
                password: null,
                confirmPassword : null,
                snackbarText : null,
                snackbarEnabled : false,
                overlay: false
            }
        },
        mounted() {

        },
        methods : {
            submitPassword() {
                if (this.password != this.confirmPassword) {
                    alert("Passwords Must Match");
                    return false;
                }

                this.overlay = true;
                api.user.selfPassword.post(this.password).then(() => {
                    this.$router.replace('/');
                },(error) => {
                    let errorShown = false;
                    if (error && error.violations) {
                        this.snackbarText = error.violations[0].message;
                        this.snackbarEnabled = true;
                        errorShown = true;
                    }
                    if (!errorShown) {
                        this.snackbarText = "Unknown Error Resetting Password";
                        this.snackbarEnabled = true;
                    }
                }).catch((c) => {
                    console.log(c);
                    alert("Unknown Error Updating Password");
                }).finally(() => {
                    this.overlay = false;
                });

                return false;

            }
        }
    }

</script>